/** @format */

import axios from "../lib/axios";
import { render } from "@react-email/render";
import {
	USER_DETAILS_FAIL,
	USER_DETAILS_REQUEST,
	USER_DETAILS_SUCCESS,
	USER_GUEST_SUCCESS,
	USER_LOGIN_FAIL,
	USER_LOGIN_REQUEST,
	USER_LOGIN_SUCCESS,
	USER_LOGOUT,
	USER_REGISTER_FAIL,
	USER_REGISTER_REQUEST,
	USER_REGISTER_SUCCESS,
} from "../constants/userConstant";
import { tokenRedirectCheck } from "../utils/tokenRedirectCheck";
import { trackEvent } from "../lib/ga";

//Register new user
export const register = (name, email, password) => async (dispatch) => {
	try {
		dispatch({
			type: USER_REGISTER_REQUEST,
		});
		//headers
		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const { data } = await axios.post("users/register", {
			name,
			email,
			password,
			config,
		});
		dispatch({
			type: USER_REGISTER_SUCCESS,
			payload: data,
		});

		dispatch({
			type: USER_LOGIN_SUCCESS,
			payload: data,
		});

		// localStorage.setItem("userInfo", JSON.stringify(data));
		return "Success";
	} catch (error) {
		dispatch({
			type: USER_REGISTER_FAIL,
			payload:
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
		});
		return "Error: " + error.response.data.message;
	}
};

//Login
export const login = (email, password) => async (dispatch) => {
	try {
		// Guest login
		if (password == null) {
			let data = {
				isGuest: true,
				email: email,
				userInfo: null,
			};

			dispatch({
				type: USER_GUEST_SUCCESS,
				payload: data,
			});

			// localStorage.setItem(
			// 	"userLogin",
			// 	JSON.stringify({
			// 		isGuest: true,
			// 		loading: false,
			// 		userInfo: { email: email },
			// 	})
			// );

			return;
		}

		dispatch({
			type: USER_LOGIN_REQUEST,
		});

		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const { data } = await axios.post(
			"users/login",
			{ email, password },
			config
		);
		dispatch({
			type: USER_LOGIN_SUCCESS,
			payload: data,
		});

		return true;

		// localStorage.setItem("userInfo", JSON.stringify(data));
	} catch (error) {
		dispatch({
			type: USER_LOGIN_FAIL,
			payload:
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
		});
		return false;
	}
};

// Sign in with Google (components/GoogleSignInButton.jsx): the ID token
// Google gave the page goes to the server, which logs in the account with
// that email or creates it. Resolves to { ok, message }.
export const googleLogin = (credential) => async (dispatch) => {
	dispatch({ type: USER_LOGIN_REQUEST });
	try {
		const { data } = await axios.post("users/google", { credential });
		const { isNew, ...userInfo } = data;
		if (isNew) dispatch({ type: USER_REGISTER_SUCCESS, payload: userInfo });
		dispatch({ type: USER_LOGIN_SUCCESS, payload: userInfo });
		trackEvent(isNew ? "sign_up" : "login", { method: "Google" });
		return { ok: true, isNew: !!isNew };
	} catch (error) {
		const message =
			error.response?.data?.message || "Google sign-in failed. Please try again.";
		dispatch({ type: USER_LOGIN_FAIL, payload: message });
		return { ok: false, message };
	}
};

//Logout
export const logout = () => async (dispatch) => {
	localStorage.removeItem("userInfo");
	dispatch({ type: USER_LOGOUT });
	return "done";
};

//User Details
export const getUserDetails =
	(userInfo, history) => async (dispatch, getState) => {
		try {
			dispatch({
				type: USER_DETAILS_REQUEST,
			});

			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${userInfo.token}`,
				},
			};
			const { data } = await axios.post("users/profile", userInfo, config);

			dispatch(tokenRedirectCheck(data, history)); //checks if token i

			dispatch({
				type: USER_DETAILS_SUCCESS,
				payload: data,
			});
		} catch (error) {
			dispatch({
				type: USER_DETAILS_FAIL,
				payload:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			});
		}
	};

export const addEmailToMailChimp = (email) => {
	const config = {
		headers: {
			"Content-Type": "application/json",
		},
	};
	axios.post("users/emailList", { email: email }, config);
};

export const addEmailToCartMailChimp = (
	email,
	tag = "Add To Cart",
	fname,
	lname
) => {
	const config = {
		headers: {
			"Content-Type": "application/json",
		},
	};
	console.log("Adding to cart on server");
	console.log(email);
	console.log(tag);
	axios
		.post(
			"users/cartMailChimp",
			{ email: email, tag: tag, fname: fname, lname: lname },
			config
		)
		.then((res) => res.data)
		.catch((err) =>
			console.log("Error adding mailchimp to cart on server", err)
		);
};

export const removeEmailFromCartMailChimp = (email) => {
	const config = {
		headers: {
			"Content-Type": "application/json",
		},
	};
	// Fire-and-forget, so a Mailchimp failure (a rejected key, an address not on
	// the list) must not become an unhandled rejection on the confirmation page.
	axios
		.post("users/removeCartMailChimp", { email: email }, config)
		.catch((err) =>
			console.log("Error removing mailchimp cart tag on server", err)
		);
};

export const apiMail = (to, subject, html, token) => {
	try {
		const body = {
			to,
			subject,
			html: typeof html === "string" ? html : render(html),
			auth: "SG1000",
		};

		if (token) {
			body.token = token;
		}

		// The surrounding try only catches render errors; a failed send is a
		// rejected promise and needs its own catch.
		axios
			.post("mail/sendMail", body)
			.catch((err) => console.log("api Mail send Error", err));
		console.log(render(html));
	} catch (e) {
		console.log("api Mail Error", e);
	}
};

export const requestRecovery = (email) => {
	axios.post("users/passwordRecoveryRequest", { userEmail: email });
};

// Returns the request so the reset screen can tell an expired link from success.
export const resetPassword = (id, password, valid) =>
	axios.post("users/resetPassword", {
		id: id,
		password: password,
		valid: valid,
	});

export const updateUserPassword =
	(userInfo, newPass, history) => async (dispatch, getState) => {
		try {
			console.log(userInfo);
			//dispatch(tokenRedirectCheck(data, history)); //checks if token i
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${userInfo.token}`,
				},
			};
			const data = await axios.post(
				"users/updatePassword",
				{ id: userInfo.id, password: newPass },
				config
			);

			dispatch(logout());
			history("/login");
		} catch (error) {}
	};

export const clearError = () => {
	return {
		type: "CLEAR_ERROR",
	};
};
